/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Asset4 from "../../../../assets/images/asset6.png";
import apiService from "../../../../api/api.service";
import { setRecommendList } from "../../../../store/recommendProduct";
import getSymbolFromCurrency from "currency-symbol-map";
import { SHOP } from "../../../../config/config";
import { Carousel } from "react-bootstrap";
import { events } from "../../../../hooks/config";
import useGAEventTracker from "../../../../hooks/useGAEventTracker";

const RecommendProduct = () => {
  const { category, action, label } = events.productRecommend;
  const GAEventsTracker = useGAEventTracker(category);
  const dispatch = useDispatch();
  const products = useSelector((state) => state.recommendProducts);
  const productRecommend = useSelector(
    (state) => state?.settings?.productRecommend
  );
  const order = useSelector((state) => state.order);
  const listProductID = [];
  order?.line_items?.map((item) =>
    listProductID.push(item.product_id.toString())
  );

  const sliceText = (text) =>
    (text.slice(0, 40) + (text.length > 40 ? "..." : ""))
      .replace(/([A-Z])/g, " $1")
      .trim();

  useEffect(() => {
    const fetchRecommendList = async () => {
      try {
        const response = await apiService.get("getRecommendProducts", {
          settingRecommend: {
            ...productRecommend,
            tags:
              productRecommend.tags && productRecommend.tags?.length
                ? productRecommend.tags
                : [],
            product_type:
              productRecommend.productType &&
              productRecommend.productType?.length
                ? productRecommend.productType
                : [],
          },
        });
        if (response.data.state === 1) {
          dispatch(setRecommendList(response.data.products));
          return;
        }
      } catch (err) {
        // console.log(err);
      }
    };

    fetchRecommendList();
  }, [dispatch]);

  useEffect(() => {
    const getListProductFromRelatedApp = async () => {
      try {
        if (productRecommend.type === "related") {
          const response = await apiService.postRelated(
            "getRelatedForProductInCart",
            {
              action: "getRelatedForProductInCart",
              shop: SHOP,
              listIdProducts: unique(listProductID),
              settings: window.omegaRelatedSettings,
            }
          );
          let productList = [];
          let productListResponse = response.data;
          for (let i = 0; i < productListResponse.length; i++) {
            let data = {
              handle: productListResponse[i].handle,
              image: productListResponse[i].image,
              title: productListResponse[i].title,
              price: productListResponse[i].variants[0]?.price,
              currency: window.Shopify?.currency.active,
            };
            productList.push(data);
          }
          dispatch(setRecommendList(productList));
        }
        return;
      } catch (err) {
        // console.log(err);
      }
    };
    getListProductFromRelatedApp();
  }, [window.omegaRelatedSettings, dispatch]);
  return (
    <>
      {products?.length !== 0 ? (
        <div className="recommend-product--text">{productRecommend.title}</div>
      ) : (
        ""
      )}
      <div
        className="card"
        style={{
          overflow: "hidden",
          borderRadius: "16px",
        }}
      >
        <Carousel variant="dark">
          {products.map((product) => (
            <Carousel.Item>
              <a
                onClick={() => {
                  GAEventsTracker(action, `${label} ${product?.title}`);
                }}
                href={`https://${product.shop}/products/${product.handle}`}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                <img
                  className="d-block recommend-product--image"
                  src={product && product.image ? product.image : Asset4}
                  alt="Nothing"
                  height="200px"
                />
                <div className="card-body recommend-product--card-body">
                  <p
                    className="recommend-product--title"
                    style={{ wordBreak: "break-all" }}
                  >
                    {" "}
                    {sliceText(product?.title)}
                  </p>
                  <p className="recommend-product--price">
                    {getSymbolFromCurrency(product?.currency)} {product?.price}
                  </p>
                </div>
              </a>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </>
  );
};

export default RecommendProduct;

function unique(arr) {
  var newArr = [];
  for (var i = 0; i < arr.length; i++) {
    if (newArr.indexOf(arr[i]) === -1) {
      newArr.push(arr[i]);
    }
  }
  return newArr;
}
